import { titleCaseLabel } from "../../utils/workspacePresentation";

function formatAcceptedAt(value) {
  if (!value) return "Not recorded";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not recorded";
  return date.toLocaleString();
}

function occupancyLabel(value) {
  if (value === "staff_technician") return "Operate under host salon";
  if (value === "independent_owner") return "Operate independently";
  if (value === "renter_guest") return "Legacy marketplace guest (deprecated)";
  return titleCaseLabel(value, "Not set");
}

function clientOwnershipLabel(value) {
  if (value === "salon_owned") return "Salon-owned clients";
  if (value === "independent_owned") return "Independent-owned clients";
  return titleCaseLabel(value, "Not set");
}

export default function AcceptedTermsSummaryPanel({
  occupancyMode,
  clientOwnershipMode,
  agreementVersion,
  acceptedAt,
  warningCount = 0,
  warningAcknowledged = false,
  paymentSummary = "",
}) {
  return (
    <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-rose-500">
        Accepted Summary
      </p>
      <div className="mt-4 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Operating relationship
          </div>
          <div className="mt-2 text-base font-semibold text-slate-900">
            {occupancyLabel(occupancyMode)}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Client ownership
          </div>
          <div className="mt-2 text-base font-semibold text-slate-900">
            {clientOwnershipLabel(clientOwnershipMode)}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Agreement version
          </div>
          <div className="mt-2 text-base font-semibold text-slate-900">
            {agreementVersion || "Not recorded"}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            Accepted at
          </div>
          <div className="mt-2 text-base font-semibold text-slate-900">
            {formatAcceptedAt(acceptedAt)}
          </div>
        </div>
      </div>
      <div className="mt-4 grid gap-3 md:grid-cols-2">
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600">
          <div className="font-semibold text-slate-900">Warnings acknowledged</div>
          <div className="mt-2">
            {warningCount} warning{warningCount === 1 ? "" : "s"} reviewed
            {warningAcknowledged ? " and acknowledged." : "."}
          </div>
        </div>
        <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600">
          <div className="font-semibold text-slate-900">Payment summary</div>
          <div className="mt-2">{paymentSummary || "Payment timing is not recorded yet."}</div>
        </div>
      </div>
    </section>
  );
}
